import { render, staticRenderFns } from "./SystemLogsView.vue?vue&type=template&id=2111442b&scoped=true"
import script from "./SystemLogsView.vue?vue&type=script&lang=ts"
export * from "./SystemLogsView.vue?vue&type=script&lang=ts"
import style0 from "./SystemLogsView.vue?vue&type=style&index=0&id=2111442b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111442b",
  null
  
)

export default component.exports